/*

FILE: videoBlock.js
DESCRIPTION: Vimeo embeds

*/

import Player from '@vimeo/player';

const initVideoBlocks = (els) => {

    els.forEach(el => {
        //console.log(el);
        const video = new Player(el.querySelector('[data-vimeo-id]'));

        el.querySelector('.play-video').addEventListener('click', () => {
            el.querySelector('.play-video').classList.add('hidden');
            el.querySelector('img').classList.add('hidden');
            el.querySelector('[data-vimeo-id]').classList.remove('hidden');
            video.play();
        });
    });
    //
    // console.log('VIDEO', video);
}

export { initVideoBlocks }
